import { formatWeekDayDateTime, userDate } from 'owa-datetime';
import loc, { format } from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import LastAction from 'owa-mail-types/lib/types/LastAction';
import Message from 'owa-service/lib/contract/Message';
import {
    infoReplyOnDate,
    infoFowardOnDate,
} from './createLastUserActionInfoBarMessage.locstring.json';
import {
    getUserLastActionForMessageItem,
    getUserLastActionTimeForMessageItem,
} from './getUserLastActionInfoBarUtils';

/**
 * This method creates infobar string for a user's last action on an item
 * In case of conversation listView type, last reply infobar is not shown in reading pane
 * Otherwise message listView and opening item in new tab show all types of infobars
 * @param message - item for which infobar is to be created
 * @param itemViewState - itemViewState of the message item
 */
export default function createLastUserActionInfoBarMessage(
    message: Message,
    itemViewState: ItemViewState
): string[] {
    let infoMessages = [];
    const lastExecutedAction = getUserLastActionForMessageItem(message);
    const actionType = LastAction[lastExecutedAction];
    const date = getUserLastActionTimeForMessageItem(message);

    if (actionType && date) {
        const formattedDate = formatWeekDayDateTime(userDate(date));
        if (
            (actionType === 'ReplyToSender' || actionType === 'ReplyToAll') &&
            !itemViewState.isConversationItemPart
        ) {
            infoMessages = [format(loc(infoReplyOnDate), formattedDate)];
        } else if (actionType === 'Forward') {
            infoMessages = [format(loc(infoFowardOnDate), formattedDate)];
        }
    }
    return infoMessages;
}
